import { Component, OnInit } from '@angular/core';
import { ProviderName, FitnessTrackerService, InputField, InputType, config, FitnessTracker } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-fitness-tracker-card',
  templateUrl: './fitness-tracker-card.component.html',
  styleUrl: './fitness-tracker-card.component.scss',
})
export class FitnessTrackerCardComponent implements OnInit {
  fitnessTrackersList$: Observable<FitnessTracker[]>;
  cardSubheading: string;
  providers = ProviderName;

  constructor(private fitnessTrackerService: FitnessTrackerService) {}

  ngOnInit(): void {
    this.fitnessTrackersList$ = this.fitnessTrackerService.getConnectedProvider();
  }

  connectFitnessTracker(providerName: ProviderName) {
    const loginUrlParameters: InputField[] = this.generateLoginParameters(providerName);
    this.fitnessTrackerService.externalConnectionToProvider(providerName, loginUrlParameters);
  }

  /**
   * Aarray of parameters required
   * to generate the tracker
   * login URL of type InputField.
   */
  generateLoginParameters(providerName: ProviderName) {
    if (providerName == ProviderName.Strava) {
      return [
        {
          FieldName: 'State',
          Value: 'test',
          InputType: InputType.Text,
          Active: true,
          ErrorMessage: '',
        },
        {
          FieldName: 'redirectUrl',
          Value: config.portalUrl + '/strava-callback',
          InputType: InputType.Text,
          Active: true,
          ErrorMessage: '',
        },
      ];
    } else {
      return [];
    }
  }

  removeFitnessTracker(providerName: ProviderName) {
    this.fitnessTrackerService.externalRevokeToProvider(providerName);
  }
}
